import RecommendedDeal from "./RecommendedDeal";

export default RecommendedDeal;
